const getEnvironmentConfig = () => {
  const env = process.env.REACT_APP_ENV;

  // Get BACKEND_URL from window (injected by Rails at runtime), then env vars, fallback to individual URLs
  // This allows Cloud Run to set BACKEND_URL per service (staging/prod) without code changes
  // Note: window.BACKEND_URL is set by Rails inline script before this module loads
  let backendUrl =
    (typeof window !== 'undefined' && window.BACKEND_URL) ||
    process.env.REACT_APP_BACKEND_URL ||
    process.env.BACKEND_URL ||
    '';

  // Normalize backend URL: ensure it has https:// protocol for production/staging
  // Cloud Run URLs should always use HTTPS to avoid mixed content errors
  if (backendUrl) {
    const originalUrl = backendUrl;
    backendUrl = backendUrl.trim();

    // Debug: log the original URL before normalization
    console.log(
      '[Environment] Original backend URL:',
      originalUrl,
      '| window.BACKEND_URL:',
      typeof window !== 'undefined' ? window.BACKEND_URL : 'N/A'
    );

    // If URL doesn't start with http:// or https://, add https://
    if (!backendUrl.match(/^https?:\/\//i)) {
      backendUrl = `https://${backendUrl}`;
    }
    // Force HTTPS for Cloud Run domains (production/staging environments)
    // This prevents mixed content errors when frontend is served over HTTPS
    if (backendUrl.match(/\.run\.app/i) || backendUrl.match(/\.a\.run\.app/i)) {
      backendUrl = backendUrl.replace(/^http:\/\//i, 'https://');
    }
    // Remove trailing slash
    backendUrl = backendUrl.replace(/\/$/, '');

    // Debug: log the normalized URL
    if (originalUrl !== backendUrl) {
      console.log(
        '[Environment] Backend URL normalized from',
        originalUrl,
        'to',
        backendUrl
      );
    } else {
      console.log('[Environment] Backend URL (already normalized):', backendUrl);
    }
  } else {
    console.warn('[Environment] No backend URL found. Sources checked:', {
      window_BACKEND_URL: typeof window !== 'undefined' ? window.BACKEND_URL : 'N/A',
      REACT_APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'N/A',
      BACKEND_URL: process.env.BACKEND_URL || 'N/A'
    });
  }

  // Get fallback base URL based on environment when no BACKEND_URL is provided
  const getFallbackBaseUrl = () => {
    switch (env) {
      case 'production':
        return 'https://api.nowcollab.com';
      case 'staging':
        return 'https://api.staging.nowcollab.com';
      case 'development':
      default:
        return 'http://localhost:8000';
    }
  };

  // Construct API URLs from BACKEND_URL if provided, otherwise use individual env vars or environment-based fallback
  const getChatUrl = () => {
    if (backendUrl) return `${backendUrl}/api/v1/chat/`;
    return process.env.REACT_APP_AI_CHAT || `${getFallbackBaseUrl()}/api/v1/chat/`;
  };

  const getRoadmapUrl = () => {
    if (backendUrl) return `${backendUrl}/api/v1/roadmap/generate`;
    return (
      process.env.REACT_APP_ROADMAP_GENERATION ||
      `${getFallbackBaseUrl()}/api/v1/roadmap/generate`
    );
  };

  const getValidateUrl = () => {
    if (backendUrl)
      return `${backendUrl}/api/v1/validation/validate-subcategory-outcome/stream`;
    return (
      process.env.REACT_APP_VALIDATION ||
      `${getFallbackBaseUrl()}/api/v1/validation/validate-subcategory-outcome/stream`
    );
  };

  const getPredictionUrl = () => {
    if (backendUrl) return `${backendUrl}/api/v1/predictions/analyze`;
    return (
      process.env.REACT_APP_PREDICTION ||
      `${getFallbackBaseUrl()}/api/v1/predictions/analyze`
    );
  };

  const getStatusUrl = () => {
    if (backendUrl) return `${backendUrl}/api/v1/roadmap/generate/status`;
    return (
      process.env.REACT_APP_ROADMAP_STATUS ||
      `${getFallbackBaseUrl()}/api/v1/roadmap/generate/status`
    );
  };
  switch (env) {
    case 'production':
      return {
        env: 'production',
        node_env: process.env.NODE_ENV,
        app_version: process.env.REACT_APP_VERSION,
        backendUrl: backendUrl,
        chatUrl: getChatUrl(),
        roadmapUrl: getRoadmapUrl(),
        status: getStatusUrl(),
        validate_url: getValidateUrl(),
        prediction_url: getPredictionUrl(),
        mixpanel_token: process.env.REACT_APP_MIXPANEL_TOKEN
      };
    case 'staging':
      return {
        env: 'staging',
        node_env: process.env.NODE_ENV,
        app_version: process.env.REACT_APP_VERSION,
        backendUrl: backendUrl,
        chatUrl: getChatUrl(),
        roadmapUrl: getRoadmapUrl(),
        status: getStatusUrl(),
        validate_url: getValidateUrl(),
        prediction_url: getPredictionUrl(),
        mixpanel_token: process.env.REACT_APP_MIXPANEL_TOKEN
      };
    case 'development':
    default:
      return {
        env: 'development',
        node_env: process.env.NODE_ENV,
        app_version: process.env.REACT_APP_VERSION,
        backendUrl: backendUrl,
        chatUrl: getChatUrl(),
        roadmapUrl: getRoadmapUrl(),
        status: getStatusUrl(),
        validate_url: getValidateUrl(),
        prediction_url: getPredictionUrl(),
        mixpanel_token: process.env.REACT_APP_MIXPANEL_TOKEN
      };
  }
};

// Evaluate config when module loads - window.BACKEND_URL should be set by Rails inline script
// which runs synchronously before javascript_pack_tag loads this bundle
export default getEnvironmentConfig();